import { render, staticRenderFns } from "./InvoiceDetailSummaryItemsTableItems.vue?vue&type=template&id=7229abb4&"
import script from "./InvoiceDetailSummaryItemsTableItems.vue?vue&type=script&lang=ts&"
export * from "./InvoiceDetailSummaryItemsTableItems.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceDetailSummaryItemsTableItems.vue?vue&type=style&index=0&id=7229abb4&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports